import Post1 from "../../Attachments/Images/post-1.webp";
import Post2 from "../../Attachments/Images/post-2.webp";
import Post3 from "../../Attachments/Images/post-3.webp";
import Post4 from "../../Attachments/Images/post-4.webp";
import Post5 from "../../Attachments/Images/post-5.webp";
import Post6 from "../../Attachments/Images/post-6.webp";
import Post7 from "../../Attachments/Images/post-7.webp";
import Post8 from "../../Attachments/Images/post-8.webp";
import Post9 from "../../Attachments/Images/post-9.webp";
import Post10 from "../../Attachments/Images/post-10.webp";

const sectionDataEN1 = {
  image: Post1,
  title:
    "Depression, Insecurity, Low Self-esteem, Excessive Emotions, Can Be Eliminated With Hypnosis Therapy",
  opening: (
    <>
      If you are reading this, maybe this article is meant for you to read.
      <br />
      <br />
      Because maybe you are going through several phases as written in the title
      above, or there are family, friends, co-workers or friends who are going
      through these phases.
      <br />
      <br />
      Each of us must have experienced this phase and that is normal. All you
      need is help from someone who understands and can help remove that feeling
      from your mind, namely your subconscious mind.
      <br />
      <br />
      Why is it called the subconscious mind? The human mind is divided into 2
      parts, there is a conscious mind and a subconscious mind, the human
      conscious mind has a role only about 10-15% of the mindset and how we make
      decisions and how we act. The rest about 85-90% is controlled by our
      subconscious mind.
      <br />
      <br />
      So there must be a moment in your life where you feel like a failure,
      heavy stress, depression, insecure and overthinking everything you have
      taken to get rid of that feeling, by seeing a psychologist, talking and
      changing ideas with friends, closest people, or religious leaders, but
      still you can't get out of those negative feelings.
      <br />
    </>
  ),
  titleC1: "There is a story that might represent your story right now:",
  C1: [
    {
      A: `A: (crying) "Sist, I'm tired of my boyfriend, he's abusing me again, I feel like I'm not considered even a little bit when I talk he will get angry, sometimes hit me. I'm tired sist.. what should I do?"`,

      B: `B: "I already told you, it's not worth you to maintain your relationship is not healthy anymore, you have to start thinking about yourself, are you happy or not?`,
    },
    {
      A: `A: (still crying) “No, but I'm afraid to lose him sist, I still love him, even though sometimes I think about breaking up because I really feel depressed too."`,

      B: `B: "Well, why are you in a relationship if you have to be depressed?"`,
    },
    {
      A: `A: "Yeah, right, I'll try, I hope I can forget him"`,

      B: `(Two weeks later, B contacted A again to ask how she is)
      B: "Sist how are you? How are you, have you broken up with him?"`,
    },
    {
      A: `A: "Hi sist, nope, I'm still with him, actually I'm tired sist but I don't think I can breakup."`,

      B: `B: (While getting angry) "Tskckckckck, It’s not logical, after a long time I was tired of accompanying you to vent until the morning but my advice was never listened to, it's up to you but if there is something bad happen to you again, so please don't contact me anymore, okay? ".`,
    },
    {
      A: `(Until one time, A got advice from someone to take hypnotherapy, and after 3 sessions, She talked to his therapist)
      A: "Ma'am, how come I'm more relaxed now. Yesterday I finally broke my relationship with him, and I didn't feel heavy at all. The burden seemed to be gone. Even though yesterday I was dating for 5 years with him , even though my heart was tormented but I chose to struggle and I don't know why.`,

      B: `
      B: "Yes, that's what hypnotherapy is for, we clean the trash that has weighed on you all this time that has caused you to tend to make wrong decisions those are not profitable for you. The values ​​that harm you are stored in your subconscious. that's what we clean and we remove, we replace it with new values ​​that are more profitable and help you to be able to take the right decision for yourself."
      `,
    },
    {
      A: `A: "Yes, even though I realize it's wrong, I choose to make wrong decisions which I don't really like without knowing why. But now I’m relieved, Ma'am. Thank you".`,
    },
  ],
  c2: (
    <>
      Hypnotherapy helps you to be able to get rid of the trash, clean thoughts
      or values ​​that are not beneficial to you that are stored in your
      subconscious.
      <br />
      <br />
      How to? As the meaning of the word hypno, itself is to bring to a relaxed
      state. Relaxation is meant to make the whole body, especially the
      conscious mind, into a very relaxed state, making it easy to activate the
      subconscious mind and reset it.
      <br />
      <br />
      Like a computer, our body is hardware and our mind is software.
      <br />
      <br />
      Software needs to be updated or even reset or installed the latest
      operating system to stay productive. Because of corrupted software, the
      overall performance of the computer will also often have problems. Just
      like the mind, a corrupted mind can result in impaired body performance,
      disease, or stress, dizziness, and various other symptoms of physical
      illness.
      <br />
      <br />
      Through hypnotherapy, it's easy to replace software that doesn't work well
      with the latest software, so you can become the best version of yourself
      in less time without hard drugs.
    </>
  ),
};

const sectionDataEN2 = {
  image: Post2,
  title: "Anger Management",
  opening: (
    <>
      Anger management problems often stem from past experiences. These
      experiences can shape your behavior and belief system. So, while you may
      think another person or situation is causing your anger, it may well come
      from yourself. Once this is understood, your hypnotherapist can begin work
      changing this.
      <br />
      <br />
      To do so, your hypnotherapist will work on a conscious and unconscious
      level to help change your negative thought processes. Doing this may
      involve relaxation techniques and suggestions from your hypnotherapist to
      help control your anger.
      <br />
      <br />
      The hope is that this will change your reaction to anger triggers. Instead
      of feeling overwhelmed and angry, you should feel calmer and more relaxed.
      Feeling calmer in stressful situations helps you to think more clearly so
      you can react in a more appropriate way.
      <br />
      <br />
      Anger management hypnotherapy can also help with some of the symptoms of
      anger. For example, if you are suffering from anxiety, stress or
      depression, hypnotherapy can be helpful.
      <br />
    </>
  ),
  titleC1: "How to deal with anger: Self-help tips:",
  c1: (
    <>
      1. Get to know your triggers
      <br />
      Understanding what situations make you feel angry is key. By recognizing
      when you are likely to feel angry, you can be prepared. To do this, start
      taking notes when you feel angry. Try to note the following:
      <br />
      <br />
      <ul className="list-disc pl-10 space-y-2">
        <li>What was the situation?</li>
        <li>Was there another person involved?</li>
        <li>What did they say/do to make you feel angry?</li>
        <li>How did you feel at the time?</li>
        <li>How did you behave?</li>
        <li>How did you feel after the incident?</li>
      </ul>
      <br />
      After a while, you should start to notice some patterns emerging. Perhaps
      you get angry when you feel belittled, or maybe you feel angrier after the
      situation because you couldn't express yourself at the time.
      <br />
      <br />
      Talk through your notes with your hypnotherapist, as this can help them
      work with you to understand the underlying reason behind your anger. Just
      recognizing these patterns can be an enormous help.
    </>
  ),
  c2: (
    <>
      2. Give yourself some time
      <br />
      A simple way to help you manage your anger when a trigger situation arises
      is to give yourself some time before you react. This allows you to really
      think about how you react, rather than reacting instinctively. Try the
      following suggestions to see if they help:
      <br />
      <br />
      <ul className="list-disc pl-10 space-y-2">
        <li>
          Take some deep breaths - breathing out for longer than you breathe in
          can help to calm you.
        </li>
        <li>
          Count to 10 - a simple act that can give you enough time to calm
          yourself before you react.
        </li>
        <li>
          Do something else - instead of reacting, try to distract yourself by
          doing something else. If you can, try to channel that energy into
          something creative.
        </li>
        <li>
          Listen to calming music/sounds - create a calming playlist and listen
          to it when you start to feel angry.
        </li>
      </ul>
      <br />
      Try a few different distraction techniques and see what works best for
      you. Again, this is something you can discuss with your hypnotherapist as
      they may have some alternative suggestions.
    </>
  ),

  c3: (
    <>
      3. Try some relaxation techniques
      <br />
      Stress and anger tend to go hand in hand. Many people find reducing their
      stress levels helps them to keep their anger under control. Relaxation
      techniques challenge the physical aspects of stress and anger. This can
      help you refrain from lashing out or behaving violently when you get
      angry. Try some of the following techniques when you are feeling stressed:
      <br />
      <br />
      <ul className="list-disc pl-10 space-y-2">
        <li>Meditation</li>
        <li>Visualization</li>
        <li>Yoga</li>
        <li>Breathing exercises</li>
      </ul>
      <br />
      One of the ways hypnotherapy for anger can help is by triggering the
      body's relaxation response. During a hypnotherapy session, you will fall
      into a deeply relaxed state. It is at this point that the hypnotherapist
      offers suggestions to help control your anger.
    </>
  ),
};

const sectionDataEN3 = {
  image: Post3,
  title: "Phobia",
  titleC1: "What Are Phobias?",
  c1: (
    <>
      A phobia is an irrational and excessive fear of a specific activity,
      situation, or object that triggers a compelling desire to avoid that
      thing. If someone has a phobia, to everyone else it may seem silly, but to
      the person with the phobia it is a genuine fear. Having this phobia is not
      their fault and not something they can “get over it”.
      <br />
      <br />
      Another way of looking at a phobia is as an unconscious automatic response
      to stimulus, which stems from a misperception of said stimulus. Scientists
      say that only two fears are hereditary or naturally instinctive: the fear
      of falling and the fear of loud noises. Everything else is learned. The
      good news is, that means it can be un-learned.
      <br />
      <br />
      Phobias usually start while we are young. However, any traumatic
      experience we endure, such as serious accidents or injuries, can cause
      phobias in adulthood.
      <br />
      <br />
      There are two main categories of phobias:
    </>
  ),
  c2: (
    <>
      <br />
      <strong>Social Phobias</strong> – fears involving other people or
      situations such as:
      <br />
      <br />
      <ul className="list-disc space-y-2 pl-10">
        <li>Public speaking</li>
        <li>Performance anxiety</li>
        <li>Embarrassment in public, such as eating</li>
        <li>General social phobia, known as social anxiety disorder</li>
        <li>
          Specific social phobias, i.e. cases of anxiety triggered only in
          specific situations such as being unable to urinate in a public
          bathroom
        </li>
      </ul>
      <br />
      <strong>Specific phobias</strong> – a fear of a single specific panic
      trigger such as:
      <br />
      <br />
      <ul className="list-disc space-y-2 pl-10">
        <li>Spiders</li>
        <li>Dogs</li>
        <li>Elevators</li>
        <li>Water</li>
        <li>Flying</li>
        <li>Death</li>
        <li>Many, many more</li>
      </ul>
      <br />
      Phobias can be severe in some individuals while others can simply avoid
      their fear trigger and have mild anxiety over that fear. Most understand
      that they suffer from an irrational fear, but they feel powerless in being
      able to overcome their instinctual panic reaction.
    </>
  ),
  titleC3: "What are the 10 Most Common Phobias?",
  c3: (
    <ul className="list-decimal space-y-2 pl-10">
      <li> Arachnophobia – the fear of spiders.</li>
      <li>
        {" "}
        Social Phobia – the fear of being evaluated negatively in social
        situations i.e. public speaking.
      </li>
      <li> Aerophobia – the fear of flying.</li>
      <li>
        {" "}
        Agoraphobia – the fear of any place or situation where escape is
        difficult.
      </li>
      <li>
        {" "}
        Claustrophobia – the fear of being trapped in small confined spaces such
        as hallways or elevators.
      </li>
      <li> Acrophobia – the fear of heights.</li>
      <li> Emetophobia – the fear of vomit.</li>
      <li> Carcinophobia – the fear of cancer.</li>
      <li> Brontophobia – the fear of thunder and lightning.</li>
      <li> Necrophobia – the fear of death.</li>
    </ul>
  ),

  titleC4: "Ending a Life Full of Irrational Fear is Possible",

  c4: (
    <>
      There is hope. Phobias can be treated. But when the fear trigger can be
      easily avoided (for the most part), a person may decide to try and ignore
      it rather than go for treatment. This can cause the phobia to manifest and
      cause disruption in one’s life in the future. A phobia may become present
      with no trigger or reason and it can be difficult to treat with standard
      psychotherapeutic techniques.
      <br />
      <br />
      There is hope. Phobias can be treated. But when the fear trigger can be
      easily avoided (for the most part), a person may decide to try and ignore
      it rather than go for treatment. This can cause the phobia to manifest and
      cause disruption in one’s life in the future. A phobia may become present
      with no trigger or reason and it can be difficult to treat with standard
      psychotherapeutic techniques.
      <br />
      <br />
      Revert that part of you, that part of your personality, to the first time
      you were aware of the cause of the current phobia. Various hypnotherapy
      techniques can help to desensitize you, reframe the initial moment about
      the fear, which allows you to function freely without it. You may be
      taught self-hypnosis techniques to help reinforce your phobia-free life.
    </>
  ),
};

const sectionDataEN4 = {
  image: Post4,
  title: "Couple Therapy",
  opening: (
    <>
      The most common caused of Couple’s Argumentation :
      <br />
      <br />
      <ul className="list-decimal pl-10 space-y-2">
        <li>Financial</li>
        <li>Being Parents / Children</li>
        <li>Housework</li>
        <li>Affair </li>
        <li>Over Protective / Jealousy</li>
        <li>Career</li>
        <li>Snoring and other sleeping habits</li>
      </ul>
      <br />
      Even a simple matter such as leaving the wet towel can cause tension in a
      relationship.
      <br />
      When couples should go to therapy together to cure the conflicts?
    </>
  ),
  titleC1: `Signs you should go to couples therapy:`,
  c1: (
    <>
      <ul className="list-disc pl-10 space-y-2">
        <li>Poor communication with your partner</li>
        <li>Feelings of boredom or numbness about your relationship</li>
        <li>Wanting to learn how to have healthy conflict</li>
        <li>Having the same fight over and over again without resolution</li>
        <li>A desire to improve your relationship</li>
        <li>Feeling distant from your partner</li>
        <li>
          Feeling like you're not getting something you need (for example, time
          or affection)
        </li>
        <li>
          Tackling a big life event (like moving, a new job, or a tough
          decision)
        </li>
        <li>Managing the transition from couple-hood to new parenthood</li>
        <li>Managing the transition from parenthood to empty nesting</li>
        <li>The presence of a betrayal (an affair or unfaithfulness)</li>
        <li>Considering a divorce or wondering if you should break up</li>
        <li>
          A desire to set a strong foundation before marriage (premarital
          counseling)
        </li>
        <li>Feeling too attached to one another (codependency)</li>
        <li>The presence of past traumas that show up in your relationship</li>
      </ul>
    </>
  ),

  c2: (
    <>
      By hypnosis, the point of view of both partners can be changed in order to
      enable the healing of their conflicts and become a healthy and positive
      relationship.
      <br />
      <br />
      The use of couple hypnotherapy can allow both partners to re-evaluate
      major events, to see things from a different perspective, and to gain more
      respect for each other’s position. Hypnosis can help re-captivate lost
      feelings of love, romance, commitment, and friendship, making it possible
      for healing to happen.
    </>
  ),
};

const sectionDataEN5 = {
  image: Post5,
  title: "Hypnoslimming",
  opening: (
    <>
      You can keep eating your favorite foods/ drinks without worrying about
      making you fat. Don’t you believe?
      <br />
      <br />
      Hypnoslimming Change Your Mindset To Lose Weight Without A Strict Diet. It
      simply turning the wrong program your mind. So far, it has been embedded
      in our mindset that eating a lot can make us fat. Even though in fact we
      can still diet with a full stomach.
      <br />
      <br />
      Opposites of other diet ways that focus on calories intake, the
      hypnoslimming method uses Neuro Linguistic Programming (NLP) techniques to
      help the root of psychometric problems in the subconscious. Hypnoslimming
      is designed to instill more positive thinking and behavior, so you can
      separate food from emotional life. As a result, you become more
      disciplined in exercising, no longer feel the urge to snack frequently,
      and consciously choose a healthier diet even though you don't follow a
      certain diet pattern.
    </>
  ),

  titleC1: "Success Story of Losing Weight by Hypnoslimming",

  c1: (
    <>
      One of well-known female presenter in Indonesia, Dewi Hughes who has
      proven that she lost 80 kg in 15 months!
      <br />
      <br />
      In her opinion, if you only want to be thin, you will do everything
      possible without thinking. For example, you are busy making a list of the
      foods you eat and their don’ts, calorie limits, portions, and the
      frequency of how many times you eat them.
      <br />
      <br />
      Dewi Hughes uses the hypnotherapy method according to her ability so that
      the diet process she goes through runs consistently. Hypnoslimming had
      straighten out her mindset by changing her goal to live a healthier life
      instead of willing to be thin. She also said the determination to lose
      weight should not come because of the desire to be thin.
    </>
  ),
};

const sectionDataEN6 = {
  image: Post6,
  title: "Addictions (Smoking, Drugs, Alcoholism, Etc.)",
  openingTitle: "Can Hypnosis Cure the Addictions?",
  opening: (
    <>
      Studies have shown that hypnosis can be effective in treating several
      medical conditions. While hypnosis to stop drinking or stop using drugs
      can be an effective behavioral tool, hypnotherapy for alcoholism and/ or
      drug addiction can be even more helpful. Hypnotherapy combines two
      modalities of treatment – hypnosis and psychotherapy.
      <br />
      <br />
      In addition to helping people better understand their addictions, it can
      also help patients be more likely to stay in a treatment program, attend
      meetings, and work with sponsors. In short: it can make patients more
      willing and amenable to various elements of the addiction treatment
      continuum.
      <br />
      <br />
      Furthermore, hypnosis’s pain-relieving properties can also be used to
      mitigate the physical barriers to recovery, including symptoms like
      withdrawal, anxiety, muscle tension, spasms, and pain.
      <br />
      <br />
      One last thing to keep in mind? Despite its potential, hypnosis is not a
      magic bullet. No single session will lead to an instant fix. Nor is it
      effective for everyone. However, it can be an effective tool that for some
      people can be used toward the process of addressing the complexities and
      challenges of addiction.
    </>
  ),
};

const sectionDataEN7 = {
  image: Post7,
  title: "Inner Child Hypnosis",
  openingTitle: "Healing Your Inner Child Through Hypnosis",
  opening: (
    <>
      Without realizing it, much of today's adult behavior and personality is
      the result of how a person's childhood was. Many cases show that bad
      experiences in childhood make a person grow up to be a coward, insecure,
      stubborn adult, traumatized by something, or even other deviant behaviors.
      <br />
      <br />
      In an Inner Child healing session, the therapist will create a metaphoric
      story for change. Where the child can explore itself and mature. A story
      that can empower the child and allow free flow of expression and
      creativity. The subconscious aspect of the true self is creative and does
      not know the difference between fact and fantasy.
      <br />
      <br />
      So letting go and trusting the subconscious mind to take in the new story
      as real is essential. The only thing that gets in the way is the critical
      faculty of the analytical mind. All we need to do is command it to step
      aside and let the healing take place.
    </>
  ),
};

const sectionDataEN8 = {
  image: Post8,
  title: "Cessation of smoking",
  opening: (
    <>
      Despite limited scientific evidence regarding its effectiveness,
      hypnotherapy is popular as a tool for stopping smoking. However, it is
      unclear whether hypnosis strengthens the will to cease the habit or if it
      lowers the desire to continue (Barnes, McRobbie, Dong, Walker, &
      Hartmann-Boyce, 2019).
      <br />
      <br />
      In their 2019 review including 14 studies and 1,926 participants, Barnes
      et al. found hypnotherapy interventions to be as effective as other forms
      of behavioral support six months after treatment.
    </>
  ),
};

const sectionDataEN9 = {
  image: Post9,
  title: "Insomnia Hypnotherapy",
  opening: (
    <>
      Insomnia is a condition when a person has difficulty sleeping or cannot
      sleep well, often wakes up during sleep, has difficulty initiating sleep,
      and cannot even achieve normal sleep quality. Insomnia most often occurs
      in the elderly which is influenced by factors of age, lifestyle,
      environment, and diet.
      <br />
      <br />
      Insomnia hypnotherapy is now widely used as a treatment method, one of
      which is a treatment for treating insomnia sufferers. Insomnia
      hypnotherapy works by entering a person's subconscious, then giving
      certain suggestions to help the healing process. The prevalence of
      insomnia in the elderly in 2014 in Indonesia was around 10%. In 2015
      around 15% and in 2016 around 17%, meaning that approximately 28 million
      of the total 238 million Indonesian population suffer from insomnia. (
      Dinkes, 2019)
      <br />
      <br />
      The state of relaxation after hypnosis can increase the client's sense of
      comfort while in bed, so that the client can easily fall asleep, a relaxed
      mind reduces the incidence of dreams, decreases the frequency of awakening
      and increases the total nighttime sleep. In addition to hypnotherapy
      factors, the therapist also provides self-hypnosis training to clients,
      self-hypnosis is self-hypnosis that can help clients achieve a relaxed
      state without being assisted by a therapist.
    </>
  ),
};

const sectionDataEN10 = {
  image: Post10,
  title: "Does Hypnotherapy Work?",
  opening: (
    <>
      While some scientists still regard hypnosis with mistrust, it has proven
      useful in clinical settings and insightful in research into mental
      processes such as “sensation, perception, learning, memory, and
      physiology” (Faymonville et al., 2006).
      <br />
      Hypnosis is seen as a heightened state of attention, concentration, and
      inner absorption, with reduced awareness of external stimuli.
      <br />
      However hypnosis requires three components (Faymonville et al., 2006):
      <br />
      <br />
      <ul className="list-disc pl-10 space-y-4">
        <li>
          Absorption – to become fully involved in the imaginative experience
        </li>
        <li>
          Dissociation – the separation of behavioral components typically
          processed together, such as being both an actor and an observer
        </li>
        <li>
          Suggestibility – the increased tendency to “comply with hypnotic
          instructions”
        </li>
      </ul>
      <br />
      <br />
      While hypnotherapy appears promising as a treatment for multiple issues
      that determine physical and psychological health, much of the research
      seems flawed because of poor trial design. Therefore, further high-quality
      studies are required to better understand its potential to improve chronic
      pain, depression, sleep, and eating disorders (Chamine et al., 2018).
      <br />
      <br />
      So, does hypnotherapy really work?
      <br />
      <br />
      Yes, science has confirmed that hypnotherapy can change our perception and
      behavior.
    </>
  ),
};

export {
  sectionDataEN1,
  sectionDataEN2,
  sectionDataEN3,
  sectionDataEN4,
  sectionDataEN5,
  sectionDataEN6,
  sectionDataEN7,
  sectionDataEN8,
  sectionDataEN9,
  sectionDataEN10,
};
